"use client";
// Standalone FlipYard has no multi-user auth (that was Tize's concept). It's a
// single-app product, so the "user" is always present. This stub keeps page.tsx's
// import unchanged after the extraction out of Tize.
export function useUser() {
  return { currentUser: "roger" as const };
}
